/**
 * Home页底部选项栏子页
 * Created at 2021-10-01 21:51
 * @author teapot
 */
import { Image } from "antd";
import { useHistory } from "react-router";
import Config from "../../config";
import { HomeContentItem } from "../../model/HomeModel";
import "./index.css";

const HomeItem = ({ props }: { props: HomeContentItem[] }) => {
  const history = useHistory();
  return (
    <>
      <div className="home-item home-width">
        {props &&
          props.map((v, i) => {
            if (JSON.stringify(v) !== "{}") {
              return (

                <div
                  className="home-item home-item-placeholder home-item-top cursors"
                  key={i}
                  style={{ marginLeft: i === 1 ? "10px" : 0, marginRight: i === 1 ? "10px" : 0 }}
                
                  onClick={() => {
                    history.push(v.url)
                  }}
                >
                  <div className="home-item-dad">
                    <Image
                      width={"100%"}
                      height={'100%'}
                      preview={false}
                      src={`${Config.MAIN_URL}${v.pic}`}
                    />
                    <div className="home-item-title">{v.title}</div>
                    <div className="home-item-content">{v.content}</div>
                  </div>
                </div>
              );
            } else {
              return <div className="home-item-left home-item-placeholder" />;
            }
          })}

      </div>
    </>
  );
};

export default HomeItem;
